import * as React from 'react'
import styled from 'styled-components'

import { TextHeading, Link, Space, Box, TextBody } from '@ally/metronome-ui'

import { FeatureFlag } from '../Utils'
import { useTransmit } from '../TransmitContext'

const InnerContainer = styled.div`
  ${({ theme: { media } }): string => `
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    ${media.down('md')} {
      flex-direction: column;
    }
  `}
`

// Added LoginContent to "visually" align the Auto login with the login form - this is technically not center if you look at the grid but looks centered visually- as requested by PO.
const LoginContent = styled.div`
  ${({ theme: { media, space } }): string => `
    margin-bottom: ${space.xxs};
    width: 100%;
    ${media.up('lg')} {
       width: 80%;
    }
  `}
`

const LoginOptions: React.FC = () => {
  const { hostServices } = useTransmit()

  const isCardNGAEnabled: boolean = hostServices?.featureFlags?.variation(
    FeatureFlag.CardNGA,
    false,
  )

  const isSPOGWebUIEnabled: boolean = hostServices?.featureFlags?.variation(
    FeatureFlag.SPOGWebUI,
    false,
  )

  return (
    <InnerContainer>
      {!isCardNGAEnabled && (
        <LoginContent>
          <TextBody size="sm" tag="p">
            Manage your{' '}
            <Link
              text="credit card"
              to="https://card.ally.com/"
              target="_blank"
              data-testid="credit-card-link"
            />
          </TextBody>
        </LoginContent>
      )}
      {!isSPOGWebUIEnabled && (
        <LoginContent>
          <TextBody size="sm" tag="p">
            Log in to{' '}
            <Link
              text="Ally Auto"
              to="https://www.ally.com/auto"
              target="_blank"
            />
          </TextBody>
        </LoginContent>
      )}
      <LoginContent>
        <TextBody size="sm" tag="p">
          Go to{' '}
          <Link
            text="Ally Lending"
            to="https://customercare.ally.com"
            target="_blank"
          />
        </TextBody>
      </LoginContent>
    </InnerContainer>
  )
}

export const ExternalLogins: React.FC = () => (
  <Box
    width={[12, 12, 12, 6]}
    display="flex"
    flexDirection="column"
    py="sm"
    maxWidth="360px"
  >
    <Box pt="14px">
      <Space mt="0" mb="sm">
        <TextHeading tag="h2" size="sm" weight="bold">
          More to do
        </TextHeading>
      </Space>
      <LoginOptions />
    </Box>
  </Box>
)
